export default class Logger {
  static isEnabled = true;

  static enableLogging() {
    Logger.isEnabled = true;
  }

  static disableLogging() {
    Logger.isEnabled = false;
  }
}
